globalThis.redoStorefront = {
  type: "bigcommerce",
  storeUrl: location.host,
  env: {
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_BIGCOMMERCE_SERVER_URL: "https://bigcommerce-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
};
// Browser polyfill: bundled deps read process.env, but only env exists at
// runtime, so bridge the partial object to the Node Process type.
// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
globalThis.process = {
  env: {
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_BIGCOMMERCE_SERVER_URL: "https://bigcommerce-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
} as unknown as typeof globalThis.process;
